import styledComponents, { ThemedBaseStyledInterface } from 'styled-components';

import { Theme } from './theme';

export const styled: ThemedBaseStyledInterface<Theme> = styledComponents;
